import { DefaultLogger } from './logger';
import { getLoggerAdapter } from './logger-factory';
import type { Logger, LoggerAdapter } from './logger-types';

export interface GetLoggerOptions {
  /**
   * Dot-separated path that mirrors the source location. Segments use the
   * casing of the codebase: kebab-case folders, camelCase hooks/files
   * (e.g. `auth.token-service`, `lib.http-client`,
   * `features.employee-groups.useDeleteEmployeeGroup`). Emitted as
   * `LogRecord.scope` on every record this logger produces.
   */
  scope: string;
}

let adapter: LoggerAdapter | undefined;

function getAdapter(): LoggerAdapter {
  if (!adapter) {
    adapter = getLoggerAdapter();
  }
  return adapter;
}

export function getLogger(options: GetLoggerOptions): Logger {
  return new DefaultLogger(getAdapter, options.scope);
}

export function setLoggerAdapter(testAdapter: LoggerAdapter): void {
  adapter = testAdapter;
}

export function resetLoggerAdapter(): void {
  adapter = undefined;
}
